export default "__VITE_ASSET__WY2oqisrzO4DrVW9CYNGXg__";